import React from 'react'

import PromotionAdminContainer from '../components/promotions/PromotionAdminContainer'

const PromotionAdminScreen = props => <PromotionAdminContainer {...props} />

export default PromotionAdminScreen
